import { useState } from 'react';
import { motion } from 'framer-motion';

export function FlashcardFlip({ front, back, onFlip }) {
    const [isFlipped, setIsFlipped] = useState(false);

    const handleFlip = () => {
        setIsFlipped(!isFlipped);
        onFlip?.(!isFlipped);
    };

    return (
        <div 
            data-testid="flashcard-flip"
            className="flashcard-container cursor-pointer"
            onClick={handleFlip}
        >
            <motion.div
                className="relative w-full h-full preserve-3d"
                animate={{ rotateY: isFlipped ? 180 : 0 }}
                transition={{ 
                    duration: 0.6, 
                    type: 'spring', 
                    stiffness: 260, 
                    damping: 20 
                }}
            >
                {/* Front */}
                <div className="absolute inset-0 backface-hidden bg-card border border-border card-shadow-light flex flex-col items-center justify-center p-8">
                    <span className="font-mono text-xs tracking-widest uppercase text-muted-foreground mb-4">
                        TERM
                    </span>
                    <p className="font-serif text-2xl md:text-3xl text-center text-card-foreground tracking-tight">
                        {front}
                    </p>
                    <span className="font-mono text-xs text-muted-foreground mt-6">
                        Click to flip
                    </span>
                </div>

                {/* Back */}
                <div 
                    className="absolute inset-0 backface-hidden bg-card border border-border card-shadow-light flex flex-col items-center justify-center p-8 rotate-y-180"
                >
                    <span className="font-mono text-xs tracking-widest uppercase text-muted-foreground mb-4">
                        DEFINITION
                    </span>
                    <p className="font-sans text-lg md:text-xl text-center text-card-foreground/90 leading-relaxed">
                        {back}
                    </p>
                    <span className="font-mono text-xs text-muted-foreground mt-6">
                        Click to flip
                    </span>
                </div>
            </motion.div>
        </div>
    );
}

export function StudyCard({ children, variant = 'default' }) {
    const bgClass = variant === 'success' 
        ? 'bg-green-500/5 border-green-500/30' 
        : variant === 'error' 
        ? 'bg-red-500/5 border-red-500/30'
        : variant === 'warning'
        ? 'bg-yellow-500/5 border-yellow-500/30'
        : 'bg-card border-border';

    return (
        <div 
            className={`w-full max-w-[600px] min-h-[300px] border card-shadow-light flex flex-col items-center justify-center p-8 ${bgClass}`}
        >
            {children}
        </div>
    );
}
